// extracted by mini-css-extract-plugin
export var button = "ieganlccWN1_EiJET5NE";
export var optionLabel = "DstXtyPmAzklWpNih1Oi";
export var optionLabelAmount = "zL6fWuUYL9XewaUSdMuu";
export var optionLabelAmountUsd = "gM3nipDES3WgnSSjGHVd";
export var optionLabelName = "q9scGluwf61CH25ON4pa";